import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';

const BetaBanner = ({ onFeedbackClick, onVisibilityChange }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if we're in staging environment
    const isStaging = import.meta.env.VITE_ENVIRONMENT === 'staging' || 
                      import.meta.env.MODE === 'development' ||
                      window.location.hostname.includes('staging') ||
                      window.location.hostname.includes('dev');
    
    // TEMPORARY: Always show banner for testing (remove this line later)
    const forceShow = true;
    
    // Always show banner when in staging or when forceShow is true (ignore dismissed state)
    if (isStaging || forceShow) {
      setIsVisible(true);
      if (onVisibilityChange) {
        onVisibilityChange(true);
      }
    }
  }, [onVisibilityChange]);

  const handleFeedbackClick = () => {
    if (onFeedbackClick) {
      onFeedbackClick();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[60px] bg-slate-50 border-b border-slate-200 shadow-sm">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-3 min-h-[60px]">
          {/* Main content */}
          <div className="flex items-center space-x-3">
            {/* Warning icon */}
            <div className="flex-shrink-0">
              <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center">
                <span className="text-lg">🚧</span>
              </div>
            </div>
            
            {/* Message */}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-700">
                <span className="hidden sm:inline">Beta Version - We're actively building. Share your feedback!</span>
                <span className="sm:hidden">Beta Version - Share feedback!</span>
              </p>
            </div>
            
            {/* Feedback button */}
            <div className="flex-shrink-0">
              <Button
                onClick={handleFeedbackClick}
                variant="outline"
                size="sm"
                className="bg-white/80 hover:bg-slate-100 border-slate-300 text-slate-700 hover:text-slate-900 shadow-sm"
              >
                <MessageCircle className="w-4 h-4 mr-1.5" />
                <span className="hidden sm:inline">Feedback</span>
                <span className="sm:hidden">Share</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetaBanner;
